import Visibility from 'semantic-ui-react/dist/commonjs/behaviors/Visibility';

export default Visibility;
